// extracted by mini-css-extract-plugin
module.exports = {"stars":"Stars_stars__11vE7","star":"Stars_star__2leMZ","descr":"Stars_descr__UgOh0"};